export default __webpack_public_path__ + "static/media/logo-min.f394c6b4.png";